import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import GradeStep from './onboarding/GradeStep';

const { FiArrowRight } = FiIcons;

/**
 * Shared child-creation fields from /setup Step B:
 * name input + grade selection (7th enabled, others Coming soon).
 */
function ChildSetupForm({
  busy = false,
  error = '',
  onCancel,
  onSubmit,
  submitLabel = 'Add child',
  submitBusyLabel = 'Saving…'
}) {
  const [childName, setChildName] = useState('');
  const [selectedGrade, setSelectedGrade] = useState('7th');

  const handleSubmit = async (event) => {
    event.preventDefault();
    await onSubmit({ name: childName, grade: selectedGrade });
  };

  return (
    <form className="flex flex-col gap-6" onSubmit={handleSubmit}>
      <label className="flex flex-col gap-1.5 text-sm font-semibold text-[#24302d]">
        Child’s name
        <input
          className="rounded-xl border border-[#e3e4de] bg-white px-4 py-3 text-sm font-normal outline-none transition focus:border-[#a78bfa] focus:shadow-[0_0_0_3px_#f3e8ff]"
          disabled={busy}
          onChange={(event) => setChildName(event.target.value)}
          placeholder="First name"
          type="text"
          value={childName}
        />
      </label>

      <GradeStep
        eyebrow="Grade"
        selectedGrade={selectedGrade}
        showContinue={false}
        showHeading={false}
        onSelect={setSelectedGrade}
      />

      {error ? (
        <p className="rounded-xl bg-[#fff0ea] px-3 py-2 text-sm text-[#ba503c]">
          {error}
        </p>
      ) : null}

      <div className="flex justify-end gap-2">
        {onCancel ? (
          <button
            className="pin-btn pin-btn-ghost"
            disabled={busy}
            onClick={onCancel}
            type="button"
          >
            Cancel
          </button>
        ) : null}
        <button
          className="flex items-center gap-2 rounded-xl bg-[#7c3aed] px-5 py-3 text-sm font-semibold text-white transition hover:bg-[#5b21b6] disabled:cursor-not-allowed disabled:opacity-50"
          disabled={busy || selectedGrade !== '7th'}
          type="submit"
        >
          {busy ? submitBusyLabel : submitLabel}
          {!busy && <SafeIcon icon={FiArrowRight} />}
        </button>
      </div>
    </form>
  );
}

export default ChildSetupForm;
